import React, { useState, useEffect } from 'react';
import BACKEND_URL from '../config'
import Sidebar from '../components/Sidebar';
import Header from '../components/Header';
import {doc, getDoc} from "firebase/firestore";
import { db, auth } from '../firebase';
import '../style/Order.css';
const StoreUrlForm = () => {
  const [storeUrl, setStoreUrl] = useState('');
  const [error, setError] = useState('');
 const [userShop, setUserShop] = useState(null);
  // Validate and format the Shopify store URL
  const validateAndFormatUrl = (url) => {
    let formattedUrl = url.trim().toLowerCase();
    // Add https:// if the URL doesn't start with it
    if (!/^https?:\/\//i.test(formattedUrl)) {
      formattedUrl = 'https://' + formattedUrl;
    }
    // Ensure it's a valid URL
    try {
      new URL(formattedUrl);
      return formattedUrl;
    } catch {
      throw new Error('Invalid URL format');
    }
  };

  const user = auth.currentUser;
  if (!user) {
    throw new Error("User not logged in");
  }


  useEffect(() => {
    const fetchUserShop = async () => {
      // Assuming db is the Firestore instance and user.uid is the current user's ID
      const userDocRef = doc(db, 'users', user.uid);
      const userDoc = await getDoc(userDocRef);
  
      // if (!userDoc.exists()) {
      //   toast.error("User data not found.");
      //   return;
      // }
  
      const userData = userDoc.data();
      const userShop = userData.shop;
      setUserShop(userShop); // Update the userShop state
      
      // setLoading(false); // Mark as done loading
    };
  
    fetchUserShop();
  }, [user.uid]); // Fetch only when the user.uid changes

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(''); // Clear any previous errors
    try {
      // Validate and format the Shopify store URL
      const formattedUrl = validateAndFormatUrl(storeUrl);
      const shop = new URL(formattedUrl).hostname;
      // **Use environment variable for backend URL**
      const backendUrl = BACKEND_URL;
      ;
      if (!backendUrl) {
        throw new Error('Backend URL is not defined');
      }
      // Redirect to your backend's auth route (which will redirect to Shopify)
      window.location.href = `${backendUrl}/api/auth?shop=${shop}`;
    } catch (error) {
      // Handle URL format error or other issues
      if (error.message === 'Invalid URL format') {
        setError('Please enter a valid Shopify store URL');
      } else {
        console.error('Error:', error);
        setError('An error occurred. Please try again.');
      }
    }
  };
  
    return (
      <div className="flex h-screen bg-white">
        <Sidebar />
        <div className="flex-1 flex flex-col min-w-0 overflow-hidden md:ml-64">
          <Header />
          <div className="flex-1 p-4 sm:p-6 lg:p-8 overflow-y-auto">
            <div className="max-w-4xl mx-auto">
              {/* Header Section */}
              <div className="text-center mb-12">
                <h1 className="text-4xl font-bold text-gray-900 mb-4 create-order-title">My Store</h1>
                <p className="text-xl text-gray-600 max-w-2xl mx-auto">
                  Connect your Shopify store to start selling your custom designs
                </p>
              </div>

              {/* Connected Store Status */}
              {userShop && (
                <div className="bg-green-50 border border-green-200 rounded-2xl p-6 mb-8">
                  <div className="flex items-center justify-center">
                    <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mr-4">
                      <svg className="w-6 h-6 text-green-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <div>
                      <h3 className="text-lg font-semibold text-green-800 mb-1">Store Connected Successfully</h3>
                      <p className="text-green-700">
                        Connected to: <span className="font-medium">{userShop}</span>
                      </p>
                    </div>
                  </div>
                </div>
              )}

              {/* Main Form Card */}
              <div className="bg-white rounded-2xl shadow-xl border border-gray-100 p-8">
                <div className="text-center mb-8">
                  <div className="w-20 h-20 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <svg className="w-10 h-10 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4" />
                    </svg>
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-2 create-order-subtitle">
                    {userShop ? 'Connect Another Store' : 'Connect Your Shopify Store'}
                  </h2>
                  <p className="text-gray-600">
                    Enter your Shopify store URL to start selling your custom designs
                  </p>
                </div>

                <form onSubmit={handleSubmit} className="max-w-md mx-auto">
                  <div className="mb-6">
                    <label htmlFor="store-url" className="block text-sm font-medium text-gray-700 mb-2">
                      Shopify Store URL
                    </label>
                    <div className="relative">
                       <div className="absolute inset-y-0 left-0 pl-3 my-2 flex items-center pointer-events-none">
                         <svg className="h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" shapeRendering="geometricPrecision" textRendering="geometricPrecision" imageRendering="optimizeQuality" fillRule="evenodd" clipRule="evenodd" viewBox="0 0 512 511.999">
                           <path fill="currentColor" d="M476.335 35.664v.001c47.554 47.552 47.552 125.365.002 172.918l-101.729 101.73c-60.027 60.025-162.073 42.413-194.762-32.45 35.888-31.191 53.387-21.102 87.58-6.638 20.128 8.512 43.74 3.955 60.08-12.387l99.375-99.371c21.49-21.493 21.492-56.662 0-78.155-21.489-21.488-56.677-21.472-78.151 0l-71.278 71.28c-23.583-11.337-50.118-14.697-75.453-10.07a121.476 121.476 0 0118.767-24.207l82.651-82.65c47.554-47.551 125.365-47.555 172.918-.001zM35.664 476.334l.001.001c47.554 47.552 125.365 47.552 172.917 0l85.682-85.682a121.496 121.496 0 0019.325-25.157c-27.876 6.951-57.764 4.015-83.932-8.805l-70.192 70.19c-21.472 21.471-56.658 21.492-78.149 0-21.492-21.491-21.493-56.658 0-78.149l99.375-99.376c20.363-20.363 61.002-26.435 91.717 1.688 29.729-3.133 41.275-8.812 59.742-26.493-39.398-69.476-137.607-80.013-194.757-22.863L35.664 303.417c-47.552 47.553-47.552 125.364 0 172.917z"/>
                         </svg>
                      </div>
                      <input
                        id="store-url"
                        type="text"
                        value={storeUrl}
                        onChange={(e) => setStoreUrl(e.target.value)}
                        placeholder="your-store.myshopify.com"
                        required
                        className="block w-full pl-10 pr-3 py-4 border border-gray-300 rounded-xl focus:ring-2 focus:ring-black focus:border-black transition-all duration-200 text-gray-900 placeholder-gray-500"
                      />
                    </div>
                  </div>

                  <button 
                    type="submit" 
                    className="w-full bg-black hover:bg-gray-800 text-white font-semibold py-4 px-6 rounded-xl transition-all duration-200 transform hover:scale-105 shadow-lg hover:shadow-xl flex items-center justify-center"
                  >
                    <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
                    </svg>
                    Connect Store
                  </button>

                  {error && (
                    <div className="mt-4 p-4 bg-red-50 border border-red-200 rounded-xl">
                      <div className="flex items-center">
                        <svg className="w-5 h-5 text-red-600 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p className="text-red-800 font-medium">{error}</p>
                      </div>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  export default StoreUrlForm;